import { render } from "./App.vue?vue&type=template&id=90ce50b6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=90ce50b6&lang=scss"

import exportComponent from "D:\\srv\\vhost\\f-cat-app\\frontend\\musicbizz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__